import { render, staticRenderFns } from "./AddCollCustomer_mobile.vue?vue&type=template&id=4872bd5a&scoped=true"
import script from "./AddCollCustomer_mobile.vue?vue&type=script&lang=js"
export * from "./AddCollCustomer_mobile.vue?vue&type=script&lang=js"
import style0 from "./AddCollCustomer_mobile.vue?vue&type=style&index=0&id=4872bd5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872bd5a",
  null
  
)

export default component.exports